import { z } from 'zod'

export const filtersAppliedSchema = z.object({
  source: z.enum(['feed', 'members_list']).optional(),
  appliedFilters: z.array(z.object({
    filter: z.string(),
    value: z.string(),
    copy: z.string().optional(),
  })),
})
